import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "items"];

  connect() {
    this.toggle();
  }

  toggle() {
    if (this.checkboxTarget.checked) {
      this.itemsTarget.style.display = "block";
    } else {
      this.itemsTarget.style.display = "none";
    }
  }
}
